import React, { useState, useEffect } from "react";
import "../../common/css/localeSelector.css";
import { setToLS, getFromLS, currencyList } from "../../common/components/LocaleSelector/currencyConfig";
import FlightCalculator from "../../common/components/offset/FlightCalculatorV2";
import logo from "../../common/media/cc_logo_white.svg";
import { projects as getProjects } from "../../common/api/projects"
import ProjectsScroll from "../../common/components/Projects/ProjectsScroll";
import Accordian from "../../common/components/Accordian/Accordian.js"
import Footer from "../components/Footer";
import { getFlightSuffix } from "../../common/util/unitConverter";
import Navigation from "../components/Navigation";
import ReactGA from "react-ga";
import ReceiptUserAgentEmail from "../components/ReceiptUserAgentEmail";
import { retryWeglotInitializing } from "../../common/util/WeglotInitializeUtil";
import { useMediaQuery } from "react-responsive";

const LandingPage = ({ merchantCode, fetchedImpact, config, currentLang, setCurrentLang }) => {
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [localSelectedCurrency, setLocalSelectedCurrency] = useState(selectedCurrency);
    const [projects, setProjects] = useState();

    const [errorEmail, setEmailError] = useState(false);
    const [emailAddr, setEmailAddr] = useState("");
    const [verifiedEmail, setVerifiedEmail] = useState(null);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [checked, setChecked] = useState(false);
    const [showEmailField, setShowEmailField] = useState(true);
    const [isAdditionalBg] = useState(true);
    const isDesktop = useMediaQuery({ query: "(max-width: 960px)" });

    const carbonOffsetImpact = fetchedImpact && !fetchedImpact.error && Math.round(fetchedImpact.carbonOffsetImpact?.value).toLocaleString();
    const carbonOffsetImpactUnit = fetchedImpact && !fetchedImpact.error && fetchedImpact.carbonOffsetImpact?.unit.toLowerCase();
    const numberOfPassengers = fetchedImpact && !fetchedImpact.error && (fetchedImpact.numberOfPassengers?.value)?.toLocaleString(); 
    const passengerDistance = fetchedImpact && !fetchedImpact.error && Math.round(fetchedImpact.passengerDistance?.value).toLocaleString();
    const passengerDistanceUnit = fetchedImpact && !fetchedImpact.error && getFlightSuffix(fetchedImpact.passengerDistance?.unit.toLowerCase())

    useEffect(() => {
        retryWeglotInitializing(50, (lang) => {setCurrentLang(lang)})
    }, []);

    useEffect(() => {
        const checkedFromStorage = window.localStorage?.getItem("allowMarketingCommunications");
        if (checkedFromStorage === "true") setChecked(true);
        else setChecked(false);
    }, []);

    useEffect(() => {
        getProjects(null, merchantCode)
            .then(response => response.json())
            .then(data => setProjects(data))
            .catch(setProjects);


    }, []);

    useEffect(() => {
        const currencyFromLC = getFromLS("currency");

        if (currencyFromLC && !selectedCurrency) {
            onChangeCurrency(currencyFromLC);
            setLocalSelectedCurrency(currencyFromLC);
        } else {
            onChangeCurrency(currencyList[0]);
        }
    }, []);

    const onChangeCurrency = (currency) => {
        if (currency) {
            setSelectedCurrency(currency);
            setToLS("currency", currency);
        }
    };

    useEffect(() => {
        if (emailAddr && validateEmail(emailAddr)) {
            setVerifiedEmail(emailAddr);
            setShowEmailField(false);
        }
    }, []);

    const validateEmail = (email) => {
        if (email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
          setEmailError(false);
          return true;
        }
    
        setEmailError(true);
        return false;
    };
    
    const handleEmailChange = (e) => {
        const { value } = e.target;
        validateEmail(value);
        setEmailAddr(value);
        setShowErrorMessage(false);
    };

    const onNext = (email) => setVerifiedEmail(email);

    const handleOnNextClick = () => { onNext(emailAddr); };

    const doNextClick = (e) => {
        e.preventDefault();
        if (validateEmail(emailAddr)) {
            setShowEmailField(false);
            handleOnNextClick();
            window.localStorage?.setItem("receiptEmailAddress", emailAddr);
            window.localStorage?.setItem("allowMarketingCommunications", checked);
        } else {
            setShowErrorMessage(true);
        }
    };

    useEffect(() => {
        const receiptEmailAddress = window.localStorage?.getItem("receiptEmailAddress");
        if (receiptEmailAddress) {
          setVerifiedEmail(receiptEmailAddress);
          setShowEmailField(false);
        }
    }, [])

    const EmailValidation = showErrorMessage && errorEmail ? (
        <div style={{ textAlign: 'center' }}>
          <span className="text-danger">Email is not valid</span>
        </div>
    ) : null;

    return (
        <main className="airport-amadeus">
            <header className="header">
                <Navigation
                    selectedCurrency={selectedCurrency}
                    onChangeCurrency={onChangeCurrency}
                    currentLang={currentLang}
                    setCurrentLang={setCurrentLang}
                    localSelectedCurrency={localSelectedCurrency}
                    setLocalSelectedCurrency={setLocalSelectedCurrency}
                    merchantCode={merchantCode}
                />
            </header>

            <section className="header-content w-100 hero-img py-6 mobile-py-0">
                <h2 className="color-white pt-5 mb-0 mw-600px">Become a Climate Friendly Travel Agent</h2>
                <p className="mt-4 mb-4 color-white text title mw-900px">Join the growing movement of Amadeus travel agents who are helping travellers make their flight climate friendly and save our planet.</p>
                <a className="no-color-btn btn-secondary btn-lg mb-3" href="#FlightCalculator">Offset Flight</a>
                <div className="d-flex v-center">
                    <p className="m-0 mr-2 color-white" style={{ fontSize: "1rem" }}>Powered by</p>
                    <a target="_blank" href="https://www.carbonclick.com/" className="mb-1">
                        <img style={{ height: 20 }} src={logo} alt="CarbonClick"/>
                    </a>
                </div>
            </section>

            <section className="pt-5 mobile-py-5">
                <div className="container text-center py-2 px-4 text">
                    <p className="mb-0 subtitle mw-940px center">
                        We all love to fly! But emissions from flying have a big impact on the environment.
                        People today want to travel more sustainably and find ways to protect our planet. 
                        Fortunately, as a travel agent, you can help your customers be climate friendly. 
                        Talk to them about carbon offsetting. All it takes is 3 easy steps.
                    </p>
                </div>
            </section>

            <section className="py-5 mobile-py-4">
                <div className="container py-2 text">
                    <div className="flex-column mb-4 text-center">
                        <h3 className="color-primary">Offset your customer’s flight</h3>
                    </div>

                    {!isDesktop && (
                        <div className="dashed-line">
                            <div className="d-flex">
                                <div className="circle mb-4">1</div>
                                <div className="circle mb-4">2</div>
                                <div className="circle mb-4">3</div>
                            </div>
                        </div>
                    )}

                    <div className="steps">
                        <div className="step">
                            {isDesktop && <div className="circle sm-circle mb-4">1</div>}
                            <div className="py-4">
                                <img src="https://res.cloudinary.com/carbonclick/image/upload/v1651152145/Enterprise/Amadeus/plane_t2zotj.svg" alt="plane icon" />
                            </div>
                            <p className="mb-5">Calculate the CO2 emissions and the cost to offset your customer’s flight.</p>
                        </div>

                        <div className="step">
                            {isDesktop && <div className="circle sm-circle mb-4">2</div>}
                            <div className="py-4">
                                <img src="https://res.cloudinary.com/carbonclick/image/upload/v1651152145/Enterprise/Amadeus/cloud_n8ovaw.svg" alt="plane icon" />
                            </div>
                            <p className="mb-5">Purchase carbon offsets from high-quality projects to make the flight climate friendly.</p>
                        </div>

                        <div className="step">
                            {isDesktop && <div className="circle sm-circle mb-4">2</div>}
                            <div className="py-4">
                                <img src="https://res.cloudinary.com/carbonclick/image/upload/v1651152145/Enterprise/Amadeus/tree_svibud.svg" alt="plane icon" />
                            </div>
                            <p className="mb-5">Your customer receives an email receipt, allowing them to instantly trace their contribution.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5 mobile-py-5">
                <div className="container text-center">
                    <div className="flex-column px-3">
                        <h3 className="color-primary">Join the climate movement</h3>
                        <p>Join a cause your customers care about and increase loyalty. Together we are already making a real difference.</p>
                    </div>

                    <div className="center pt-4">
                        <div className="row text-align-start m-0 impact">
                            <div className="col-4 d-grid">
                                <div className="center w-100 br-b-6">
                                    <div className="img-cover h-240px impact-flight w-100 br-t-6 br-b-6"></div>
                                    <div className="my-3">
                                        <h4 className="font-bold ammount">{numberOfPassengers}</h4>
                                        <p>Flights Offset</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-4 d-grid">
                                <div className="center w-100 br-b-6">
                                    <div className="img-cover h-240px impact-CO2 w-100 br-t-6 br-b-6"></div>
                                    <div className="my-3">
                                        <h4 className="font-bold ammount">{carbonOffsetImpact} <span className="unit">{carbonOffsetImpactUnit}</span></h4>
                                        <p>of Carbon Offset</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-4 d-grid">
                                <div className="center w-100 br-b-6">
                                    <div className="img-cover h-240px impact-km w-100 br-t-6 br-b-6"></div>
                                    <div className="mt-3">
                                        <h4 className="font-bold ammount">{passengerDistance} <span className="unit">{passengerDistanceUnit}</span></h4>
                                        <p>of flying offset</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <section className="flight-calculator-section bg-linear" id="FlightCalculator">
                <div className="container mobile-p-0">
                    <div className="center flight-calculator-wrapper bg-white">
                        <ReceiptUserAgentEmail
                            setEmailAddr={setEmailAddr}
                            handleEmailChange={handleEmailChange}
                            verifiedEmail={verifiedEmail}
                            doNextClick={doNextClick}
                            showEmailField={showEmailField}
                            emailAddr={emailAddr}
                            EmailValidation={EmailValidation}
                            checked={checked}
                            setChecked={setChecked}
                            setShowEmailField={setShowEmailField}
                        />
                        <div className="flight-calculator-unset-font">

                            <FlightCalculator
                                receiptEmailAddress={verifiedEmail}
                                checked={checked}
                                merchantCode={merchantCode}
                                currency={selectedCurrency}
                                onChangeCurrency={onChangeCurrency}
                                currencyList={currencyList}
                            />
                        </div>
                    </div>
                </div>
            </section>

            {Array.isArray(projects) && <>
                <section id="Projects" className="py-5 mobile-py-4 projects translate-dynamic">
                    <div className="container text-center">
                        <div className="mb-5 center">
                            <h3 className="color-primary">Support projects that make a real difference</h3>
                            <p className="text">All projects undergo rigorous, continued auditing, ensuring carbon offsets go to authentic, high-quality climate initiatives. The projects selected by Amadeus have been chosen for the positive impact they have on both the environment and local communities.</p>
                        </div>
                        <div className="text-align-start mobile-text-center">
                            <ProjectsScroll projects={projects} isAdditionalBg={isAdditionalBg} lang={currentLang} />
                        </div>
                    </div>
                </section>
            </>}


            <section id="FAQ" className="py-5 mobile-py-5">
                <div className="container text-center">
                    <h3 className="mb-4 color-primary">FAQs</h3>
                    <div className="mb-3 center text-align-start mw-800px">
                        <Accordian title={"Who are CarbonClick?"}>CarbonClick is a New Zealand enviro-tech company, and our carbon offsetting partner of choice. They exist to reverse climate change. By making carbon offseting simple, trustworthy and meaningful. CarbonClick empowers businesses and their customers with the right tools to start tackling their carbon emissions.</Accordian>
                        <Accordian title={"Why should I ask my customers to offset?"}>Climate change affects all of us. While we all love to fly, we also have to realise that flying can make up a significant part of a traveler's annual emissions. For example, in the UK, just one long haul return flight is likely to represent 25% of person’s total carbon emissions for one year. Carbon offsetting empowers your customer to take instant climate action, leaving a positive impact for our planet.</Accordian>
                        <Accordian title={"How are the emissions calculated?"}>Emissions are calculated based on the individual route flown, taking into account the distance travelled as well as the type of aircraft, seating configuration, aircraft age, and typical load factors on your particular route.</Accordian>
                        <Accordian title={"What is Carbon Offsetting?"}>Voluntary carbon offsetting is a way to compensate for unavoidable carbon emissions. To do this, organisations support projects that positively impact the environment and reduce or avoid carbon emissions that would have otherwise contributed to climate change. If the positive impact of this support negates the negative impact they have, ie: if the emissions avoided equal the original emissions of an activity, that activity is said to be “offset”. In most circumstances, the activity or product can now be classified as carbon neutral as far as you’ve offset. Alternatively, a business may be able to offset this themselves and claim carbon neutrality or net zero carbon.</Accordian>
                        <Accordian title={"What if a customer cancels or amends their booking and wants a refund?"}>When your customer cancels their booking you can email support@carbonclick.com to request a refund for your customer. Please let us know the transaction reference number, the date, and the customer’s email address. Offsets will be refunded within 10 working days back to the method in which they were paid.
                            <span style={{ display: 'block' }}>If your customer amends their booking and would like the offset to reflect the new flightprint, please request a refund for the original transaction and purchase a new carbon offset.</span></Accordian>
                    </div>
                </div>
            </section>

            <Footer />
        </main>
    )
}

export default LandingPage;
